import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/logo.png';

const Header: React.FC = () => {
  const location = useLocation();
  
  // Auto-scroll to top on page navigation
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  return (
    <header className="site-header">
      <div className="logo">
        <Link to="/" className="logo-link">
          <img src={logo} alt="Sip'N'Security Logo" className="logo-image" />
          <h1>Sip'N'Security</h1>
        </Link>
      </div>
      <nav className="navigation">
        <ul>
          <li className={location.pathname === '/' ? 'active' : ''}>
            <Link to="/">Home</Link>
            <span className="nav-underline"></span>
          </li>
          <li className={location.pathname === '/store' ? 'active' : ''}>
            <Link to="/store">Store</Link>
            <span className="nav-underline"></span>
          </li>
          <li className={location.pathname === '/podcast' ? 'active' : ''}>
            <Link to="/podcast">Podcast</Link>
            <span className="nav-underline"></span>
          </li>
          <li className={location.pathname === '/blog' ? 'active' : ''}>
            <Link to="/blog">Blog</Link>
            <span className="nav-underline"></span>
          </li>
          <li className={location.pathname === '/contact' ? 'active' : ''}>
            <Link to="/contact">Contact</Link>
            <span className="nav-underline"></span>
          </li>
          <li className={location.pathname === '/admin/login' ? 'active' : ''}>
            <Link to="/admin/login">Admin</Link>
            <span className="nav-underline"></span>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
